export default __webpack_public_path__ + "static/tabs-importance-do-537eea73687b500666d5a20597e402bf3bb7ca115e11a837bea50013203a0470.png";